import React, { useEffect, useMemo, useState } from "react";
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

import TableContainer from "components/Common/DataTableContainer";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import CreateSebelUser from "./CreateSebelUser";

import { deleteSebelUser, updateSebelUser } from "store/actions"; // You must have these actions

const SebelUserTable = ({ List, loading }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState();
  const [deleteId, setDeleteId] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);
  const permissions = JSON.parse(localStorage?.getItem('permissions')) || [];
  const hasEditPermission = permissions.some(item => item?.permissionName === "Edit Sebel UserId");
  const hasDeletePermission = permissions.some(item => item?.permissionName === "Delete Sebel UserId");

  const handleDelete = (id) => {
    dispatch(deleteSebelUser(id));
    setDeleteId('');
    setOpenModal(false);
    setConfirmAction(false);
  };

  useEffect(() => {
    if (deleteId && confirmAction) {
      handleDelete(deleteId);
    }
  }, [deleteId, confirmAction]);

  const columns = useMemo(() => [
    {
      header: 'Siebel User ID',
      accessorKey: 'sabelUserId',
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: 'Siebel User Name',
      accessorKey: 'sabelUserName',
      enableColumnFilter: false,
      enableSorting: true,
    },
    ...(hasEditPermission || hasDeletePermission
      ? [{
        header: 'Actions',
        id: 'actions',
        cell: ({ row }) => {
          const rowData = row.original;

          const handleEdit = () => {
            setEditData(rowData);
            setIsOpen(true);
          };

          return (
            <div className="d-flex gap-2">
              {hasEditPermission && (
                <Button color="primary" onClick={handleEdit}>
                  <FaRegEdit size={18} />
                </Button>
              )}
              {hasDeletePermission && (
                <Button color="danger" onClick={() => {
                  setDeleteId(rowData?.id || rowData?.sebelUserId);
                  setOpenModal(true);
                }}>
                  <MdDeleteOutline size={18} />
                </Button>
              )}
            </div>
          );
        }
      }]
      : [])
  ], [hasEditPermission, hasDeletePermission]);

  const handleSubmit = (data,onClose) => {
    dispatch(updateSebelUser(data,onClose));
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <ConfirmationModal
        okText={"Confirm"}
        onCancel={() => {
          setDeleteId('');
          setOpenModal(false);
        }}
        onOk={() => setConfirmAction(true)}
        isVisible={openModal}
        title="Delete Siebel User"
        content="Are you sure you want to delete this Siebel User?"
      />

      <CreateSebelUser
        visible={isOpen}
        initialData={editData}
        onSubmit={handleSubmit}
        handleClose={handleClose}
      />

      <div className="container-fluid">
        <TableContainer
          loading={loading}
          columns={columns}
          data={List || []}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder="Search..."
          pagination="pagination"
          docName="Siebel Users"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      </div>
    </>
  );
};

export default SebelUserTable;
